import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { withTheme } from 'styled-components';
// Import Components
import Logo from './components/HeaderLogo';
import Nav from './layouts/HeaderNav';
// Import Component Styles
import { Header, HeaderWrapper, MenuButton } from './styles';

const HeaderSection = withTheme(({ theme, ...props }) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  // Menu transitions stay off until the user toggles the menu, so crossing the desktop
  // breakpoint swaps layouts without a flash of the mobile menu sliding away
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const desktop = window.matchMedia('(min-width: 1200px)');
    const onBreakpointChange = () => {
      setAnimate(false);
      setOpen(false);
    };
    // Safari < 14 only supports the older addListener/removeListener API
    if (desktop.addEventListener) {
      desktop.addEventListener('change', onBreakpointChange);
      return () => desktop.removeEventListener('change', onBreakpointChange);
    }
    desktop.addListener(onBreakpointChange);
    return () => desktop.removeListener(onBreakpointChange);
  }, []);

  const toggleMenu = () => {
    setAnimate(true);
    setOpen(!open);
  };

  return (
    <HeaderWrapper>
      <Header as="nav">
        <Logo locale={props.locale} />
        <MenuButton
          iconType={open ? 'x' : 'menu'}
          open={open}
          color="white"
          iconSize={25}
          aria-label={intl.messages[open ? 'nav-close-menu-button' : 'nav-open-menu-button']}
          aria-expanded={open}
          onClick={toggleMenu}
        />
        <Nav {...props} open={open} setOpen={setOpen} animate={animate} page="nav" />
      </Header>
    </HeaderWrapper>
  );
});

export default HeaderSection;
